import React from "react";
import { Button, Col, Image, Row, Stack } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { IDocument } from "../../../customTypings/document/Document";
import { IFolder } from "../../../customTypings/document/Folder";
import { Avatar } from "../../common/Avatar/Avatar";

interface DocumentListViewProps {
  folders: IFolder[];
  documents: IDocument[];
  removeActionActive: boolean;
  onFolderClick: (folder: IFolder) => void;
  onDocumentClick: (document: IDocument) => void;
  onRemoveFolder: (folder: IFolder) => void;
  onRemoveDocument: (document: IDocument) => void;
  onAddFile: () => void;
  onToggleRemove: () => void;
}

export const DocumentListView: React.FC<DocumentListViewProps> = ({
  folders,
  documents,
  removeActionActive,
  onFolderClick,
  onDocumentClick,
  onRemoveFolder,
  onRemoveDocument,
  onAddFile,
  onToggleRemove,
}) => {
  const listIconStyle = { width: "2rem", height: "2rem" };

  return (
    <Stack direction="vertical">
      <div className="bg-light px-2 py-1 mb-2">
        <Row>
          <Col xs={6}>Name</Col>
          <Col xs={3}>Date modified</Col>
          <Col xs={3}>User</Col>
        </Row>
      </div>

      {folders &&
        folders.map((folder) => (
          <Button
            key={folder.id}
            variant={
              removeActionActive ? "outline-danger" : "outline-primary"
            }
            className="w-100 mb-1 border-0"
            onClick={() =>
              removeActionActive
                ? onRemoveFolder(folder)
                : onFolderClick(folder)
            }
          >
            <Stack direction="horizontal" gap={2}>
              {removeActionActive && <FontAwesomeIcon icon={faTrash} />}
              <Image
                src={`/api/thumbnail/a43ab016-c96c-4911-86cd-b3a9687d89c2`}
                style={listIconStyle}
                className="image-contain"
              />
              {folder.name}
            </Stack>
          </Button>
        ))}
      {documents &&
        documents.map((document) => (
          <Button
            key={document.id}
            variant={
              removeActionActive ? "outline-danger" : "outline-primary"
            }
            className="w-100 mb-1 border-0 text-start"
            onClick={() =>
              removeActionActive
                ? onRemoveDocument(document)
                : onDocumentClick(document)
            }
          >
            <Row>
              <Col xs={6}>
                <Stack direction="horizontal" gap={2}>
                  {removeActionActive && (
                    <FontAwesomeIcon icon={faTrash} />
                  )}
                  <Image
                    src={`/api/thumbnail/${document.documentThumbnailId}`}
                    style={listIconStyle}
                    className="image-contain"
                  />
                  {document.fileName}
                </Stack>
              </Col>
              <Col xs={3} className="lh-lg">
                {`${document.dateAdded}`}
              </Col>
              <Col xs={3} className="lh-lg">
                <Avatar identity={document.identity} />
              </Col>
            </Row>
          </Button>
        ))}
      <div>
        <Button
          variant="outline-primary"
          className="w-auto mb-1 text-start"
          onClick={onAddFile}
        >
          <Stack direction="horizontal" gap={2}>
            <FontAwesomeIcon icon={faPlus} size="2x" className="me-1" />
            Add File
          </Stack>
        </Button>
      </div>
      <div>
        <Button
          variant="outline-danger"
          className="w-auto mb-1 text-start"
          onClick={onToggleRemove}
        >
          <Stack direction="horizontal" gap={2}>
            <FontAwesomeIcon icon={faTrash} size="2x" className="me-1" />
            Delete File
          </Stack>
        </Button>
      </div>
    </Stack>
  );
};
